import axios from 'axios';
import { customAxios } from '../../../common/customAxios';

interface postImageProps {
  category: string;
  reqBody: {
    file: File;
  };
}

export const postImage = ({ category, reqBody }: postImageProps): Promise<{ url: string }> => {
  return customAxios.post(`/images/${category}`, reqBody, {
    headers: { 'Content-Type': 'multipart/form-data', charset: 'utf-8' },
  });
};
